export const genderMDM = [
  { id: 0, code: "01", label: "Madame" },
  { id: 1, code: "02", label: "Monsieur" },
  { id: 2, code: "--", label: "Autre" },
];